import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { PromptContentSubcomponent } from "appworks/components/prompt/prompt-content-subcomponent";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";

export class AgsPromptComponent extends PromptComponent {
    public showPrompt(prompt: PromptContentSubcomponent, loadStage: number = null): Contract<void> {
        if (prompt.layer.id === "Alerts") {
            gameWrapper.gamePopupShown();
            prompt.onHide.addOnce(() => gameWrapper.gamePopupHidden());
        }
        return super.showPrompt(prompt, loadStage);
    }
}